module.exports = __webpack_public_path__ + "e1ccdc6029222b182222b894f32cb018.png";